import React from 'react';
import i18next from 'i18next';

import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import en from './dashboard-user/i18n/en';
import it from './dashboard-user/i18n/it';

const DashboardUserPage = lazyRetry(() => import('./dashboard-user/DashboardUserPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	routes: [
		{
			path: 'summary/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'dashboard_admin'),
			element: <DashboardUserPage />
		}
	]
};

export default routes;
